/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useContext, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../../../assets/styledSvg/logo";
import { ReactComponent as Bell } from "../../../assets/svg/bell.svg";
import { ReactComponent as Settings } from "../../../assets/svg/settings.svg";
import { AccountStateEnum, AuthContext } from "../../../contexts/AuthContext";
import { NotificationContext } from "../../../contexts/NotificationContext";
import { PageEndpointEnum } from "../../../enums/endpoint";
import useOutsideAlerter from "../../../hooks/outsideAlerter/useOutsideAlerter";
import useScreenSize from "../../../hooks/screenSize/useScreenSize";
import useKeydownHandler, {
  KeydownHandlerKeyEnum,
} from "../../../hooks/useKeydownHandler";
import { SettingsModal } from "../../SettingsModal";
import AccountDropdown from "../AccountDropdown";
import { NotificationPanel } from "../NotificationPanel";
import AboutMarginXModal from "./AboutMarginXModal";
import { HeaderNav } from "./HeaderNav";
import {
  BellBadge,
  BellWrapper,
  HeaderButton,
  LeftHeaderWrapper,
  MainHeaderWrapper,
  NotificationButton,
  RightHeaderComponent,
  RightHeaderWrapper,
} from "./style";
import DesktopPWAModal from "../PWAFlowModal/DesktopPWAModal";
import { PWA_UI_ENABLED } from "../../../constants/featureFlags";

export function Header() {
  // NOTIFICATIONS
  const { showPanel, setShowPanel, unreadCount, unreadAlertCount } = useContext(NotificationContext);
  const { accountApiKeyState } = useContext(AuthContext);
  const modalRef = useRef(null);
  const notifButtonRef = useRef(null);

  const [showSettingsModal, setShowSettingsModal] = useState<boolean>(false);
  const [showPWAFlow, setShowPWAFlow] = useState<boolean>(false);
  const [showAboutMarginXModal, setShowAboutMarginXModal] = useState(false);

  const { isMobileScreen } = useScreenSize();

  const onHide = useCallback(() => {
    setShowPanel(false);
  }, [setShowPanel]);

  useOutsideAlerter([modalRef, notifButtonRef], onHide);
  useKeydownHandler(KeydownHandlerKeyEnum.ESC, onHide);

  const onTriggerPanel = useCallback(() => {
    setShowPanel(!showPanel);
  }, [setShowPanel, showPanel]);

  const onSettingsClick = useCallback(() => {
    setShowSettingsModal(true);
  }, []);

  const onShowPWAFlow = useCallback(() => {
    setShowPWAFlow(true);
  }, []);

  return (
    <MainHeaderWrapper>
      <SettingsModal
        show={showSettingsModal}
        onHide={() => setShowSettingsModal(false)}
        showOptionsChainSettings={!isMobileScreen}
      />
      <NotificationPanel modalRef={modalRef} />
      <AboutMarginXModal
        show={showAboutMarginXModal}
        onHide={() => setShowAboutMarginXModal(false)}
      />
      {/* PWA disabled from UI/UX — flip PWA_UI_ENABLED to re-enable */}
      {PWA_UI_ENABLED && (
        <DesktopPWAModal
          show={showPWAFlow}
          onHide={() => setShowPWAFlow(false)}
        />
      )}
      <LeftHeaderWrapper>
        <Link to={PageEndpointEnum.TRADING}>
          <Logo height={32} width={32} />
        </Link>
      </LeftHeaderWrapper>
      <HeaderNav setShowAboutMarginXModal={setShowAboutMarginXModal} />
      <RightHeaderWrapper>
        {accountApiKeyState === AccountStateEnum.OK && (
          <NotificationButton
            onClick={() => onTriggerPanel()}
            ref={notifButtonRef}
            aria-label="Notifications"
          >
            <BellWrapper>
              <Bell />
              {unreadCount > 0 && (
                <BellBadge $alert={unreadAlertCount > 0}>
                  {unreadCount > 99 ? "99+" : unreadCount}
                </BellBadge>
              )}
            </BellWrapper>
          </NotificationButton>
        )}
        <RightHeaderComponent>
          {/* <BalanceMarginUtilization /> */}
          <AccountDropdown onSyncPWA={onShowPWAFlow} />
          {/* <HeaderButton onClick={onShowPWAFlow}>
            <Phone />
          </HeaderButton> */}
          {/* Icon-only: without a name the button is unreachable by any
              assistive tech. Plain English, matching the Notifications button
              directly above rather than the t() style used inside AccountModal. */}
          <HeaderButton onClick={onSettingsClick} aria-label="Settings">
            <Settings />
          </HeaderButton>
        </RightHeaderComponent>
      </RightHeaderWrapper>
    </MainHeaderWrapper>
  );
}
